<ng-container *ngIf="page_summary_data_loaded">
    <div class="summary-section">
        <div class="each-summary-section" style="background: #D0E0E3;">
            <div class="each-summary-heading-section">
                <!-- <span>Agent 1</span> -->
                <span>AI Agent 1</span>
                <div class="section-heading-tooltip-block">
                  <img src="assets/info-black.png" />
                  <div class="section-heading-tooltip-section" style="width: 300px; left: -100px; right: unset;">
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_1_explanation"></p>
                  </div>
                </div>
            </div>
            <div class="each-summary-content-section">
                <!-- <div class="each-view-explanantion-section">
                    <p class="view-explanantion-heading">Explanation</p>
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_1_explanation"></p>
                </div> -->
                <div class="each-summary-details-section" *ngFor="let summary of page_summary_data.agent_1_data">
                    <p class="each-summary-details-label">{{summary.name}}</p>
                    <p class="each-summary-details-value">{{summary.value}}</p>
                    <ng-container *ngIf="summary.sub">
                        <div class="each-summary-inner-details-section" *ngFor="let sub of summary.sub">
                            <p class="each-summary-details-sub-label">{{sub.name}}</p>
                            <p class="each-summary-details-sub-value">{{sub.value}}</p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="each-summary-section" style="background: #E1E9F3;">
            <div class="each-summary-heading-section">
                <!-- <span>Agent 2</span> -->
                <span>AI Agent 2</span>
                <div class="section-heading-tooltip-block">
                  <img src="assets/info-black.png" />
                  <div class="section-heading-tooltip-section" style="width: 300px; left: -100px; right: unset;">
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_2_explanation"></p>
                  </div>
                </div>
            </div>
            <div class="each-summary-content-section">
                <!-- <div class="each-view-explanantion-section">
                    <p class="view-explanantion-heading">Explanation</p>
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_2_explanation"></p>
                </div> -->
                <div class="each-summary-details-section" *ngFor="let summary of page_summary_data.agent_2_data">
                    <p class="each-summary-details-label">{{summary.name}}</p>
                    <p class="each-summary-details-value">{{summary.value}}</p>
                    <ng-container *ngIf="summary.sub">
                        <div class="each-summary-inner-details-section" *ngFor="let sub of summary.sub">
                            <p class="each-summary-details-sub-label">{{sub.name}}</p>
                            <p class="each-summary-details-sub-value">{{sub.value}}</p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="each-summary-section" style="background: #D9EAD3;">
            <div class="each-summary-heading-section">
                <!-- <span>Agent 3</span> -->
                <span>AI Agent 3</span>
                <div class="section-heading-tooltip-block">
                  <img src="assets/info-black.png" />
                  <div class="section-heading-tooltip-section" style="width: 300px; left: -100px; right: unset;">
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_3_explanation"></p>
                  </div>
                </div>
            </div>
            <div class="each-summary-content-section">
                <!-- <div class="each-view-explanantion-section">
                    <p class="view-explanantion-heading">Explanation</p>
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_3_explanation"></p>
                </div> -->
                <div class="each-summary-details-section" *ngFor="let summary of page_summary_data.agent_3_data">
                    <p class="each-summary-details-label">{{summary.name}}</p>
                    <p class="each-summary-details-value">{{summary.value}}</p>
                    <ng-container *ngIf="summary.sub">
                        <div class="each-summary-inner-details-section" *ngFor="let sub of summary.sub">
                            <p class="each-summary-details-label">{{sub.name}}</p>
                            <p class="each-summary-details-value">{{sub.value}}</p>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="each-summary-section" style="background: #FFF2CC;">
            <div class="each-summary-heading-section">
                <!-- <span>Agent 4</span> -->
                <span>AI Agent 4</span>
                <div class="section-heading-tooltip-block">
                  <img src="assets/info-black.png" />
                  <div class="section-heading-tooltip-section" style="width: 250px; left: -100px; right: unset;">
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_4_explanation"></p>
                  </div>
                </div>
            </div>
            <div class="each-summary-content-section">
                <!-- <div class="each-view-explanantion-section">
                    <p class="view-explanantion-heading">Explanation</p>
                    <p class="view-explanantion-content" [innerHTML]="page_summary_data.agent_4_explanation"></p>
                </div> -->
                <!-- <div class="each-summary-details-section" *ngFor="let summary of page_summary_data.agent_4_data">
                    <p class="each-summary-details-sub">{{summary.name}}</p>
                    <p class="each-summary-details-sub-value" [innerHTML]="summary.value"></p>
                    <ng-container *ngIf="summary.sub">
                        <div class="each-summary-inner-details-section" *ngFor="let sub of summary.sub">
                            <p class="each-summary-details-label">{{sub.name}}</p>
                            <p class="each-summary-details-value">{{sub.value}}</p>
                        </div>
                    </ng-container>
                </div> -->

                <div class="each-summary-details-section" *ngFor="let summary of page_summary_data.agent_4_data; let index = index">
                    <p class="each-summary-details-label" [ngStyle]="index === 1 ? {'margin-bottom':'12px'} : null">{{summary.name}}</p>
                    <p class="each-summary-details-sub-value" *ngIf="index !== 1" [innerHTML]="summary.value" [ngStyle]="index === 1 ? {'font-size': '14px','font-style':'italic', 'color':'#3f51b5'} : null"></p>
                    <ng-container *ngIf="index === 1 && summary.value.length > 0">
                        <ul style="list-style-type: disc;">
                            <li *ngFor="let sub of summary.value" style="font-size: 14px;font-style:italic; color:#3f51b5">
                            {{sub}}
                            </li>
                        </ul>
                    </ng-container>
                    <ng-container *ngIf="index === 1 && summary.value.length == 0">
                        <p class="each-summary-details-sub-value">NA</p>
                    </ng-container>
                </div>

            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!page_summary_data_loaded">
    <app-loader [loading_text]="'Loading'"></app-loader>
</ng-container>
